import { RootProps } from './Types'
import Styles from './Root.module.scss'
import { useInterruptBrowserBack } from 'components/Wizards/Wizard/useInterruptBrowserBack'

const Root = ({ children }: RootProps) => {
  useInterruptBrowserBack()

  return <div className={Styles.root}>{children}</div>
}

export { Root }
